module.exports = __webpack_public_path__ + "static/media/community-builder-5.80868a75.jpg";